"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommercialSubscriptionCancel = exports.CommercialSubscriptionSharedUpdateFields = exports.CommercialSubscriptionSharedCreateFields = exports.CommercialPaymentDetails = exports.CommercialSubscriptionSharedQuery = exports.CommercialSubscriptionSharedFields = exports.CommercialSubscriptionTimeRestriction = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../../common");
const collection_relation_update_1 = require("../../common/collection-relation-update");
const enums_1 = require("../enums");
exports.CommercialSubscriptionTimeRestriction = typebox_1.Type.Object({
    onlyAfter: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'time' })), // If set, the location should not be serviced before this time
    onlyBefore: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'time' })), // If set, the location should not be serviced after this time
});
exports.CommercialSubscriptionSharedFields = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    subscriptionNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    accountExecutiveID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    serviceLocation: common_1.ServiceLocationTransport,
    poNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    timeRestriction: typebox_1.Type.Optional(exports.CommercialSubscriptionTimeRestriction),
    gateCode: typebox_1.Type.Optional(typebox_1.Type.String()),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: enums_1.CommercialSubscriptionStatus,
    files: typebox_1.Type.Array(common_1.S3ItemReference, {
        description: 'References to files associated with the subscription. Set type to "placement" for images ' +
            'indicating container placements. Set type to "issue" for images related to service issues.',
    }),
    // Denormalized fields
    customerName: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerCompanyName: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerAccountNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: common_1.MetaData,
});
exports.CommercialSubscriptionSharedQuery = typebox_1.Type.Object({
    subscriptionIDs: typebox_1.Type.String(), // comma separated list of CommercialSubscription ids
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    isActive: typebox_1.Type.Boolean(),
    hasPoNumber: typebox_1.Type.Boolean(),
    hasTimeRestriction: typebox_1.Type.Boolean(),
    hasGateCode: typebox_1.Type.Boolean(),
    hasContract: typebox_1.Type.Boolean(),
    status: typebox_1.Type.String(), // Comma separated list of CommercialSubscriptionStatus values. One day we'll figure out how to represent that in Typebox.
});
exports.CommercialPaymentDetails = typebox_1.Type.Object({
    paymentMethod: typebox_1.Type.Optional(common_1.PaymentMethod),
    selectedCardID: typebox_1.Type.Optional(typebox_1.Type.String()),
    stripeCustomer: typebox_1.Type.Optional(typebox_1.Type.String()),
    checkNumber: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.CommercialSubscriptionSharedCreateFields = typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CommercialSubscriptionSharedFields, [
        'id',
        'haulerID',
        'equipment',
        'billingDetails',
        'servicePeriods',
        'status',
        'contracts',
        'metadata',
    ]),
    typebox_1.Type.Object({
        equipment: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })), // Will be replaced with SubscriptionEquipmentCreate
        billingDetails: typebox_1.Type.String({ format: 'uuid' }), // Will be replaced with BillingDetailsCreate
        servicePeriods: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }))), // Will be replaced with ServicePeriodCreate
        contract: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })), // Will be replaced with CommercialContractCreate
    }),
]);
exports.CommercialSubscriptionSharedUpdateFields = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Omit(exports.CommercialSubscriptionSharedFields, [
        'id',
        'haulerID',
        'customerID',
        'equipment',
        'subscriptionNumber',
        'billingDetails',
        'servicePeriods',
        'poNumber',
        'timeRestriction',
        'gateCode',
        'notes',
        'status',
        'contracts',
        'metadata',
    ]),
    typebox_1.Type.Object({
        equipment: typebox_1.Type.Optional((0, collection_relation_update_1.CollectionRelationUpdate)(typebox_1.Type.String({ format: 'uuid' }), // Will be replaced with SubscriptionEquipmentCreate
        typebox_1.Type.String({ format: 'uuid' }), // Will be replaced with SubscriptionEquipmentUpdate
        typebox_1.Type.String({ format: 'uuid' }))),
        contracts: typebox_1.Type.Optional((0, collection_relation_update_1.CollectionRelationUpdate)(typebox_1.Type.String({ format: 'uuid' }), // Will be replaced with CommercialContractCreate
        typebox_1.Type.String({ format: 'uuid' }), // Will be replaced with CommercialContractUpdate
        typebox_1.Type.String({ format: 'uuid' }))),
        subscriptionNumber: (0, common_1.Nullable)(typebox_1.Type.String()),
        billingDetails: typebox_1.Type.String({ format: 'uuid' }), // Will be replaced with BillingDetailsUpdate
        servicePeriods: typebox_1.Type.Optional((0, collection_relation_update_1.CollectionRelationUpdate)(typebox_1.Type.String({ format: 'uuid' }), // Will be replaced with ServicePeriodCreate
        typebox_1.Type.String({ format: 'uuid' }), // Will be replaced with ServicePeriod
        typebox_1.Type.String({ format: 'uuid' }))),
        timeRestriction: typebox_1.Type.Object({
            onlyAfter: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String({ format: 'time' }))),
            onlyBefore: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.String({ format: 'time' }))),
        }),
        poNumber: (0, common_1.Nullable)(typebox_1.Type.String()),
        notes: (0, common_1.Nullable)(typebox_1.Type.String()),
        gateCode: (0, common_1.Nullable)(typebox_1.Type.String()),
        cancellationReason: typebox_1.Type.String(),
    }),
]));
exports.CommercialSubscriptionCancel = typebox_1.Type.Object({
    cancellationReason: typebox_1.Type.Optional(typebox_1.Type.String()),
    cancelDate: typebox_1.Type.String({ format: 'date' }),
});
//# sourceMappingURL=commercial-subscription-shared.js.map